import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Not1',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/SaleInfo',
    name: 'SaleInfo',
    component: () => import('../views/SaleInfo/SaleInfo.vue')
  },
  {
    path: '/',
    name: 'menu',
    component: () => import('../views/menu/menu.vue'),
    redirect: (_to) => {
      return { path: '/Home' }
    },
    children: [
      {
        path: '/Home',
        name: 'Home',
        component: () => import('../views/Home.vue')
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('../views/user/user.vue')
      }
    ]
  },

  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  }
]

const router = createRouter({
  // 使用 Hash 路由以兼容 Electron 桌面端的 file:/// 及多窗口场景
  history: createWebHashHistory(),
  routes
})

export default router
